/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState } from "react";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, Typography } from "@mui/material";
import { Close, AddCircle } from "@mui/icons-material";
import { closelightbox } from "../../util/Functions";
import { ModalStyle } from "../../util/Styles";
import { DateRangePicker } from "../elements/DateRangePicker";
import { initDay, endDay, parseDate } from '../elements/DateRangePicker';

const ModalSearchSpaceList = (props) => {
  const [disabled, setDisabled] = useState(true);
  const [option, setOption] = useState({ key: "", label: "", value: "" })
  const [search, setSearch] = useState([])
  const [err, setErr] = useState(false)
  const [options, setOptions] = useState([
    { key: "tracking_key", label: "Clave de Rastreo" },
    { key: "uuid", label: "ID Transacción" },
    { key: "mcc", label: "MCC" },
    { key: "channel", label: "Canal" },
    { key: "amount", label: "Monto" },
    { key: "date", label: "Fecha" },
  ])

  const [newDates, setNewDates] = useState({
    startDate: initDay,
    endDate: endDay,
  });

  const change = (field, e) => {
    if (field === "option") {
      if (JSON.parse(e.target.value).key === "date") {
        setOption({ key: JSON.parse(e.target.value).key, label: JSON.parse(e.target.value).label, value: props.date })
      } else {
        setOption({ key: JSON.parse(e.target.value).key, label: JSON.parse(e.target.value).label, value: "" })
      }
    } else {
      setOption({ key: option.key, label: option.label, value: e.target.value })
    }
  };

  const addSearch = async (key, value, label) => {
    let filterOptions = []
    var test = true
    search.map((i) => { if (i.hasOwnProperty("start_date")) { return test = false } })

    var infoValidate = []
    if (key !== "tracking_key" && key !== "uuid" && key !== "date" && test) {
      setSearch(data => ([...data, { [key]: value.replace(/\s/g, ''), label: label }, { "start_date": newDates.startDate, label: "Fecha de Inicio" }, { "end_date": newDates.endDate, label: "Fecha de Fin" }]))
      filterOptions = options.filter((item) => {
        if (item.key !== "date" && item.key !== key) {
          return item
        }
      })
      infoValidate = [...search, { [key]: value.replace(/\s/g, ''), label: label }, { "start_date": newDates.startDate, label: "Fecha de Inicio" }, { "end_date": newDates.endDate, label: "Fecha de Fin" }]
      validate(infoValidate)
    } else {
      filterOptions = options.filter((item) => {
        if (item.key !== key) {
          return item
        }
      })

      if (key === "date") {
        setSearch(data => ([...data, { "start_date": newDates.startDate, label: "Fecha de Inicio" }, { "end_date": newDates.endDate, label: "Fecha de Fin" }]))
        infoValidate = [...search, { "start_date": newDates.startDate, label: "Fecha de Inicio" }, { "end_date": newDates.endDate, label: "Fecha de Fin" }]
      } else {
        setSearch(data => ([...data, { [key]: value.replace(/\s/g, ''), label: label }]))
        infoValidate = [...search, { [key]: value.replace(/\s/g, ''), label: label }]
      }
      validate(infoValidate)
    }

    setOptions(filterOptions)
    setOption({ key: "", label: "", value: "" })
  }

  const deleteSearch = async (name) => {
    if (name.label === 'Fecha de Inicio') {
      let filterOptions = search.filter((item) => {
        if ("start_date" !== Object.keys(item)[0] && "end_date" !== Object.keys(item)[0]) {
          return item
        }
      })
      setOptions(data => ([...data, { key: "date", label: "Fecha" }]))
      setSearch(filterOptions)
      validate(filterOptions)
    } else {
      let filterOptions = search.filter((item) => {
        if (Object.keys(name)[0] !== Object.keys(item)[0]) {
          return item
        }
      })
      setOptions(data => ([...data, { key: Object.keys(name)[0], label: name.label }]))
      setSearch(filterOptions)
      validate(filterOptions)
    }
  }

  const validate = (items) => {
    var aux = []
    if (items.length > 0) {
      items.map((i) => {
        aux.push(Object.keys(i)[0])
      })
      if ((aux.includes("channel") || aux.includes("mcc") || aux.includes("amount")) && (!aux.includes("start_date") && !aux.includes("uuid") && !aux.includes("tracking_key"))) {
        setDisabled(true)
        setErr(true)
        return
      } else {
        setErr(false)
        setDisabled(false)
      }
    } else {
      setDisabled(true)
    }
  }

  const filter = () => {
    let genericFilters = search
    genericFilters = genericFilters.map((item) => {
      delete item.label
      return item
    })
    props.filter(genericFilters, true);
    closelightbox();
  };

  const updateDates = (data) => {
		setNewDates({
			startDate: parseDate(data.startDate, "start"),
			endDate: parseDate(data.endDate, "end"),
		});
	}

  return (
    <Dialog open={true} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          Filtro Avanzado
          <IconButton id="headButton" onClick={closelightbox}><Close /></IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item xs={4}>
              <TextField
                label="Filtrar por:" value={JSON.stringify({ key: option.key, label: option.label })} onChange={change.bind(this, "option")} select size="small" fullWidth >
                <MenuItem value={JSON.stringify({ key: option.key, label: option.label })}>Selecciona</MenuItem>
                {options.map((item, index) => (
                  <MenuItem key={`option-${index}`} value={JSON.stringify({ key: item.key, label: item.label })}>{item.label}</MenuItem>
                ))}
              </TextField>
            </Grid>

            {option.key &&
              <>
                <Grid item xs={7}>
                  {option.key == "amount" ?
                    <TextField onChange={change.bind(this, option)} value={(option.value)} label={option.label} name={option.label} size="small" type={"number"} fullWidth inputProps={{ style: { width: "100%", textAlign: "initial" } }} />
                    : option.key == "date" ?
                      <DateRangePicker updateDates={updateDates.bind(this)} startDate={props.date.startDate} endDate={props.date.endDate}/>
                      :
                      <TextField onChange={change.bind(this, option)} value={option.value} label={option.label} name={option.label} size="small" fullWidth />
                  }
                </Grid>
                <Grid item xs={1}>
                  <IconButton disabled={option.value ? false : true} title={`Agregar`} edge="end" onClick={() => addSearch(option.key, option.value, option.label)} >
                    <AddCircle />
                  </IconButton>
                </Grid>
              </>
            }

            {search?.length > 0 &&
              <Grid item xs={12}>
                <hr style={{ margin: "6px 0 14px 0" }} />
                <p style={{ padding: "0px" }}>Datos de búsqueda: </p>

                <Grid container spacing={2} sx={{ marginTop: "10px", fontStyle: "oblique", color: "#969BA0" }}>
                  {search?.map((item, index) => {
                    if (item.hasOwnProperty("start_date") || item.hasOwnProperty("end_date")) {
                      return <Grid item xs={6} key={index} sx={{ display: "flex", paddingTop: "8px !important" }}>{item.hasOwnProperty("start_date") ? <Close titleAccess={`Eliminar opción`} onClick={() => deleteSearch(item)} cursor={"pointer"} fontSize={"small"} /> : null}<Typography sx={{ marginLeft: "12px" }} >{Object.values(item)[1]}: {String(Object.values(item)[0]).split("T")[0]}</Typography></Grid>
                    } else {
                      return <Grid item xs={12} key={index} sx={{ display: "flex", paddingTop: "8px !important" }}><Close titleAccess={`Eliminar opción`} onClick={() => deleteSearch(item)} cursor={"pointer"} fontSize={"small"} /><Typography sx={{ marginLeft: "12px" }} >{Object.values(item)[1]}: {Object.values(item)[0]}</Typography></Grid>
                    }
                  })}
                  {err && <Grid item xs={12} sx={{ display: "flex", paddingTop: "8px !important" }}><Typography fontSize={"0.8rem"} color="red" sx={{ marginLeft: "12px" }} >El tipo de búsqueda debe incluir un rango de fecha o identificador.</Typography></Grid>}
                </Grid>
              </Grid>
            }
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>
          <Button disabled={disabled} variant="contained" onClick={filter} >Filtrar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default ModalSearchSpaceList;
